/**
 * Auth abstraction.
 *
 * - Password auth: tRPC auth.login/signup minting our JWTs.
 * - Passkey auth: SimpleWebAuthn backend (see passkey-auth.ts).
 */
export type {
  PasswordAuthAdapter,
  PasswordSignInResult,
  PasswordSignUpResult,
} from './password-auth';
export { createJwtPasswordAuth } from './password-auth-jwt';
export {
  isPasskeySupported,
  registerPasskey,
  authenticateWithPasskey,
} from './passkey-auth';

import { createJwtPasswordAuth } from './password-auth-jwt';
import type { PasswordAuthAdapter } from './password-auth';

type JwtMutations = {
  loginMutation: { mutateAsync: (input: { email: string; password: string }) => Promise<{ accessToken: string; refreshToken: string }> };
  signupMutation: { mutateAsync: (input: { email: string; password: string }) => Promise<{ accessToken: string; refreshToken: string }> };
};

/**
 * Create the password auth adapter for the login/signup screens.
 */
export function createPasswordAuthAdapter(deps: JwtMutations): PasswordAuthAdapter {
  return createJwtPasswordAuth(deps.loginMutation, deps.signupMutation);
}
